import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  CreateOpenPositionDto,
  OpenPositionDto,
  UpdateOpenPositionDto,
} from "../interfaces/HR/openPosition";

const endpoint = `${apiVariable}`;

const authHeaders = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getOpenPositions = async (token: string) => {
  const { data } = await axios.get<OpenPositionDto[]>(endpoint, authHeaders(token));
  return data;
};

export const getAllPositions = async (token: string) => {
  const { data } = await axios.get<OpenPositionDto[]>(
    `${endpoint}/getAllPositions`,
    authHeaders(token),
  );
  return data;
};

export const getOpenPositionById = async (token: string, id: string) => {
  const { data } = await axios.get<OpenPositionDto>(
    `${endpoint}/getOpenPositionById/${id}`,
    authHeaders(token),
  );
  return data;
};

export const createOpenPosition = async (
  token: string,
  payload: CreateOpenPositionDto,
) => {
  const { data } = await axios.post<OpenPositionDto>(
    `${endpoint}/createOpenPosition`,
    payload,
    authHeaders(token),
  );
  return data;
};

export const updateOpenPosition = async (
  token: string,
  payload: UpdateOpenPositionDto,
) => {
  const { data } = await axios.put<OpenPositionDto>(
    `${endpoint}/updateOpenPosition`,
    payload,
    authHeaders(token),
  );
  return data;
};

export const closeOpenPosition = async (token: string, id: string) => {
  const { data } = await axios.put<OpenPositionDto>(
    `${endpoint}/closePosition/${id}`,
    undefined,
    authHeaders(token),
  );
  return data;
};

export const deleteOpenPosition = async (token: string, id: string) => {
  await axios.delete(`${endpoint}/deletePosition/${id}`, authHeaders(token));
};
